/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFormTemplateRequest
 */
export interface UpdateFormTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFormTemplateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormTemplateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormTemplateRequest
     */
    category?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFormTemplateRequest
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateFormTemplateRequest
     */
    displayOrder?: number;
}

/**
 * Check if a given object implements the UpdateFormTemplateRequest interface.
 */
export function instanceOfUpdateFormTemplateRequest(value: object): value is UpdateFormTemplateRequest {
    return true;
}

export function UpdateFormTemplateRequestFromJSON(json: any): UpdateFormTemplateRequest {
    return UpdateFormTemplateRequestFromJSONTyped(json, false);
}

export function UpdateFormTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFormTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
    };
}

export function UpdateFormTemplateRequestToJSON(json: any): UpdateFormTemplateRequest {
    return UpdateFormTemplateRequestToJSONTyped(json, false);
}

export function UpdateFormTemplateRequestToJSONTyped(value?: UpdateFormTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'category': value['category'],
        'isActive': value['isActive'],
        'displayOrder': value['displayOrder'],
    };
}

